import gql from 'graphql-tag';

const duplicateVideoQuery = gql`
  mutation DuplicateVideo($videoId: String!) {
    duplicateVideo(videoId: $videoId) {
      videoId
    }
  }
`;

const duplicateVideo = {
  mutation: duplicateVideoQuery,
  module: 'video',
  buildVariables: (videoId: string) => ({ videoId })
} as const;

export default duplicateVideo;
